import axios from "../customize_axios";

export const getTotalRevenue = async (token) => {
    try {
        const response = await axios.get(
            "api/order/revenue",
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response.data
    } 
    catch (error) {
        console.log("getTotalRevenue: ", error.response ? error.response.data : error.message)    
    }
};

export const getTotalOrders = async (token) => {
    try {
        const response = await axios.get(
            "api/books/sold-quantity/count",
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response.data
    } 
    catch (error) {
        console.log("getTotalOrders: ", error.response ? error.response.data : error.message)    
    }
};

export const getTotalBooks= async (token) => {
    try {
        const response = await axios.get(
            "api/books/count",
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response.data
    } 
    catch (error) {
        console.log("getTotalBooks: ", error.response ? error.response.data : error.message)    
    }
};

export const getTotalUsers = async (token) => {
    try {
        const response = await axios.get(
            "api/user/count",
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response.data
    } 
    catch (error) {
        console.log("getTotalCustomers: ", error.response ? error.response.data : error.message)    
    }
};
export const getCountAllOrderStatus = async (token) => {
    try {
        const response = await axios.get(
            "api/order/admin/count",
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response.data
    } 
    catch (error) {
        console.log("getCountOrderStatus: ", error.response ? error.response.data : error.message) 
    }
} 
export const getCountOrderStatus = async (token, dateRange) => {
    try {
        const response = await axios.get(
            `api/order/admin/count?start=${dateRange.start}&end=${dateRange.end}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response.data
    } 
    catch (error) {
        console.log("getCountOrderStatus: ", error.response ? error.response.data : error.message) 
    }
}

export const getPaymentPercent = async (token) => {
    try {
        const response = await axios.get(
            "api/payment/percent",
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response.data
    } 
    catch (error) {
        console.log("getPaymentPercent: ", error.response ? error.response.data : error.message) 
    }
}

export const getBestSellerBook = async (token, page) => {
    try {
        const response = await axios.get(
            `api/books/admin/best-seller?page=${page}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response.data
    } 
    catch (error) {
        console.log("getBestSellerBook: ", error.response ? error.response.data : error.message) 
    }
}
